import React, { useCallback, useState } from "react";
import { Server, X } from "lucide-react";
import UpdateOSField from "./UpdateOSField";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function UpdateOSPopup({ updatedOS, closePopup, confirm }) {

    const [os, setOS] = useState(updatedOS);

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onContinueClick = () => {
        closePopup();
        confirm(os);
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-update-os-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <Server size={18} />
                        </div>
                        <div>
                            <h4 id="oct-update-os-title" className="oct-shared-popup__title">Edit Host OS</h4>
                            <p className="oct-shared-popup__subtitle">Update the operating system details detected for this host.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close update host OS popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <UpdateOSField value={os} onChange={(value) => setOS(value)} disabled={false} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!os}
                        onClick={onContinueClick}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    )

}

export default UpdateOSPopup;
